






import Vue from "vue";
import MapMarker from "./MapMarker.vue";

import lineSliceAlong from '@turf/line-slice-along';
import along from '@turf/along';
import length from "@turf/length";
import nearestPointOnLine from "@turf/nearest-point-on-line";
import { GeoJSONSource } from 'mapbox-gl';

import { TripsLayer } from '@deck.gl/geo-layers';
import { MapboxLayer } from '@deck.gl/mapbox';
import { Geometry, Properties, Feature, LineString, Point } from '@turf/helpers';
import { PathLayer } from '@deck.gl/layers'
import distance from '@turf/distance';
import { addLayer, pixelDistance } from '../utils/MapUtils';
import { hexToArray, brandColor, brandColorDark, trackColor } from '../utils/Utils';

export default Vue.extend({

	components: {
		MapMarker,
	},

	inject: ["$map"],
	
	props: {
		trackFeature: {
			type: Object as () => Feature,
			default: null,
		},
		progress: {
			type: Number,
			default: 0,
		}
	},

	data() {
		return {
		}
	},

	computed: {
		trackLength():number {
			return length(this.trackFeature);
		},

		layer():MapboxLayer {
			return this.$map.getLayer('line-animation');
		},

		baseLayer():MapboxLayer {
			return this.$map.getLayer('line-base');
		},


		timestamps() {
			//generate "timestamps" for TripsLayer. An array of progress values (0-1) for each point in the track.
			let coords:number[][] = (this.trackFeature.geometry as Geometry).coordinates as number[][];
			let totalLength = length(this.trackFeature);
			let tot = 0;
			let c = coords.reduce((out, c, index, arr) => {
				let dist = index > 0 ? distance(arr[index], arr[index-1]) : 0;
				tot += dist;
				out.push(tot/totalLength)
				return out;
			}, [] as any);
			return c;
		}

		/*
		posFeature():Feature<Point> {
			const feature = along((this.trackFeature.geometry as LineString), this.trackLength * Math.max(this.progress, 0.0000001), {units:"kilometers"});
			feature.properties = {type: "current"}
			return feature;
		}
		*/
	},

	methods: {
		initMap() {
			let baseLayer = new MapboxLayer({
				type: PathLayer,
				id: "line-base",
				data: [this.trackFeature as any],
				pickable: false,
				widthUnits: "pixels",
				// widthScale: 20,
				// widthMinPixels: 6,
				getPath: (feature:Feature) => (feature.geometry as Geometry).coordinates,
				
				getPolygonOffset: () => [0, 20000],

				getColor: hexToArray(brandColorDark()) as any,
				getWidth: 3,
				rounded: false,
				miterLimit: 30,
				billboard: true,
				depthTest: false,
			});
			addLayer(this.$map, baseLayer);

			const layer = new MapboxLayer({
				type: TripsLayer,
				id: "line-animation",
				data: [this.trackFeature as any],
				pickable: false,
				widthUnits: "pixels",
				// widthScale: 20,
				// widthMinPixels: 6,
				getPath: (feature:Feature) => (feature.geometry as Geometry).coordinates,
				getTimestamps: (feature:Feature) => {
					return this.timestamps;
				},
				getColor: f => hexToArray(trackColor()) as any,
				getWidth: 6,
				trailLength: 10,
				rounded: false,
				miterLimit: 30,
				billboard: true,
				currentTime: 1,
				depthTest: false,
			});
			addLayer(this.$map, layer);

			this.initMouse();
			
			this.drawMap();
		},

		drawMap(){
			this.layer.implementation.setProps({currentTime: this.progress})
		},

		initMouse() {
			this.$map.on('mousemove', e=> {
				const pt = nearestPointOnLine(this.trackFeature, e.lngLat.toArray())

				const distance = pixelDistance(pt.geometry.coordinates, e.lngLat, this.$map)

				if(distance < 30)
					this.$emit("setProgress", pt.properties.location / this.trackLength, "track");
				else
					this.$emit("setProgress", 1, undefined);
			});
		}
	},

	watch: {
		progress(){
			this.drawMap();
		},

		trackFeature(){
			this.baseLayer.implementation.setProps({data: [this.trackFeature]})
			this.layer.implementation.setProps({data: [this.trackFeature]})
			this.drawMap();
		}
	},

	mounted() {
		this.initMap();
	},
});
